import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { BillData } from "../../types/bill/billTypes";
import axiosInstance from "../../axios/axiosInstance";

interface BillState {
  billLoading: boolean;
  billSuccess: boolean;
  billError: any;
  billData: BillData | null;
}

const initialState: BillState = {
  billLoading: false,
  billSuccess: false,
  billError: null,
  billData: null,
};

export const fetchBill = createAsyncThunk<any, string>(
  "bill/fetchBill",
  async (ref, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`https://app.ceylonhospitals.com/bill/${ref}`);
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue("An unknown error occurred while fetching bill");
      }
    }
  }
);

const billSlice = createSlice({
  name: "bill",
  initialState,
  reducers: {
    clearBillSuccess: (state) => {
      state.billSuccess = false;
    },
    resetBillState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBill.pending, (state) => {
        state.billLoading = true;
        state.billSuccess = false;
        state.billError = null;
        state.billData = null;
      })
      .addCase(fetchBill.fulfilled, (state, action) => {
        state.billLoading = false;
        state.billSuccess = true;
        state.billData = action.payload;
      })
      .addCase(fetchBill.rejected, (state, action) => {
        state.billLoading = false;
        state.billError = action.payload;
      });
  },
});

export const { clearBillSuccess, resetBillState } = billSlice.actions;
export default billSlice.reducer;